import React, { useEffect, useState, useMemo } from 'react';
import SearchableDropdown from '../TicketComponents/SearchableDropdown';
import { useApiClient } from '../../service/API';

export default function UrgentTicketRaiseReport() {
    const apiClient = useApiClient();

    const [userList, setUserList] = useState([]);
    const [userEmail, setUserEmail] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [loading, setLoading] = useState(false);

    const today = useMemo(() => new Date().toISOString().slice(0, 10), []);

    const fetchUserList = async () => {
        try {
        const userListGet = await apiClient.get(`/users/bouser-list`);
        const all = { email: '', id: '', fullname: 'All' };
        setUserList([all, ...userListGet.data]);
        } catch (error) {
        // console.error(error, 'Error fetching user list. Please contact IT support.');
        }
    };

    useEffect(() => {
        fetchUserList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleStartDateChange = (e) => {
        const newStart = e.target.value;

        // Optional rule: prevent selecting future start date
        // Remove this if you want future allowed.
        if (newStart && newStart > today) {
        alert('Start date cannot be in the future.');
        return;
        }

        setStartDate(newStart);

        // If existing endDate becomes invalid, clear it immediately
        if (endDate && newStart && new Date(endDate) < new Date(newStart)) {
        setEndDate('');
        }
    };

    const handleEndDateChange = (e) => {
        const newEnd = e.target.value;

        // Enforce end >= start
        if (startDate && newEnd && new Date(newEnd) < new Date(startDate)) {
        alert('End date cannot be earlier than Start date.');
        return;
        }

        // Optional rule: prevent selecting future end date
        // Remove this if you want future allowed.
        if (newEnd && newEnd > today) {
        alert('End date cannot be in the future.');
        return;
        }

        setEndDate(newEnd);
    };

    const handleSelectionChange = (selectedEmail) => {
        setUserEmail(selectedEmail);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
        const response = await apiClient.get('/export/urgent-ticket-report', {
            params: {
            startDate: startDate || undefined,
            endDate: endDate || undefined,
            userEmail: userEmail || undefined,
            },
            responseType: 'blob',
        });

        const blob = response.data;
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'Urgent Ticket Report.xlsx';
        link.click();
        URL.revokeObjectURL(link.href);
        } catch (error) {
        // console.error("There was an error fetching the job stats", error);
        } finally {
        setLoading(false);
        }
    };


    return (
        <div className="dashboard">
            <h1>Urgent Ticket Report</h1>
    
            <form onSubmit={handleSubmit}>
            <div>
                <label>Email:</label>
                <SearchableDropdown
                options={userList}
                selectedValue={userEmail}
                onSelectedChange={handleSelectionChange}
                placeholder="Select user"
                />
            </div>
    
            <div>
                <label>Start Range Of Created Date:</label>
                <input
                type="date"
                value={startDate}
                onChange={handleStartDateChange}
                // Optional rule: prevent future start date
                max={today}
                />
            </div>
    
            <div>
                <label>End Range Of Created Date:</label>
                <input
                type="date"
                value={endDate}
                onChange={handleEndDateChange}
                disabled={!startDate}
                min={startDate || undefined} // ✅ allows going back within Jan if startDate is in Jan
                // Optional rule: prevent future end date
                max={today}
                />
            </div>
    
            <button type="submit" disabled={loading}>
                {loading ? 'Loading...' : 'Export Urgent Ticket Report'}
            </button>
            </form>
        </div>
    );
}